export const ACTIVITY_TYPE_INPUT = 'input'
export const ACTIVITY_TYPE_OUTPUT = 'output'

export const ACTIVITY_TYPE = {
  [ACTIVITY_TYPE_INPUT]: 'Entrada',
  [ACTIVITY_TYPE_OUTPUT]: 'Saída',
}

export const SELECT_ACTIVITY_TYPES = [
  { value: 'input', label: ACTIVITY_TYPE.input },
  { value: 'output', label: ACTIVITY_TYPE.output },
]
